import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/projects', label: 'Projects' },
  { to: '/donate', label: 'Donate' },
];

const PublicNav = () => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-50 btn btn-primary"
      >
        Skip to main content
      </a>

      <nav
        role="navigation"
        aria-label="Primary navigation"
        className="sticky top-0 z-40 bg-white/95 backdrop-blur-sm border-b border-secondary-200"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link
              to="/"
              className="flex items-center space-x-2 no-underline hover:no-underline"
              aria-label="Second Story Initiative — home"
            >
              <img
                src="/brand/logo-96.png"
                alt=""
                className="h-9 w-9 rounded-full object-cover flex-shrink-0"
                aria-hidden="true"
              />
              <span className="font-semibold text-secondary-900">Second Story</span>
            </Link>

            {/* Desktop nav */}
            <div className="hidden sm:flex items-center space-x-4">
              {navLinks.map((link) => {
                const isActive = location.pathname === link.to;
                return (
                  <Link
                    key={link.to}
                    to={link.to}
                    aria-current={isActive ? 'page' : undefined}
                    className={
                      isActive
                        ? 'px-3 py-2 text-sm text-primary-700 font-semibold rounded-lg bg-primary-50 no-underline hover:no-underline'
                        : 'px-3 py-2 text-sm text-secondary-600 hover:text-secondary-900 font-medium rounded-lg hover:bg-secondary-50 no-underline hover:no-underline transition-colors'
                    }
                  >
                    {link.label}
                  </Link>
                );
              })}
              <Link
                to="/login"
                className="px-3 py-2 text-sm text-secondary-600 hover:text-secondary-900 font-medium rounded-lg hover:bg-secondary-50 no-underline hover:no-underline transition-colors"
              >
                Sign In
              </Link>
              <Link to="/register" className="btn btn-primary btn-sm ml-2">
                Get Started
              </Link>
            </div>

            {/* Mobile hamburger */}
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="sm:hidden p-2 text-secondary-600 hover:text-secondary-900 rounded-lg hover:bg-secondary-50"
              aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={mobileOpen}
            >
              {mobileOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile dropdown */}
        {mobileOpen && (
          <div className="sm:hidden border-t border-secondary-200 bg-white">
            <div className="px-4 py-3 space-y-1">
              {navLinks.map((link) => {
                const isActive = location.pathname === link.to;
                return (
                  <Link
                    key={link.to}
                    to={link.to}
                    onClick={() => setMobileOpen(false)}
                    aria-current={isActive ? 'page' : undefined}
                    className={
                      isActive
                        ? 'block px-3 py-2 text-sm text-primary-700 font-semibold rounded-lg bg-primary-50 no-underline hover:no-underline'
                        : 'block px-3 py-2 text-sm text-secondary-600 hover:text-secondary-900 font-medium rounded-lg hover:bg-secondary-50 no-underline hover:no-underline transition-colors'
                    }
                  >
                    {link.label}
                  </Link>
                );
              })}
              <Link
                to="/login"
                onClick={() => setMobileOpen(false)}
                className="block px-3 py-2 text-sm text-secondary-600 hover:text-secondary-900 font-medium rounded-lg hover:bg-secondary-50 no-underline hover:no-underline transition-colors"
              >
                Sign In
              </Link>
              <Link
                to="/register"
                onClick={() => setMobileOpen(false)}
                className="block btn btn-primary btn-sm text-center mt-2"
              >
                Get Started
              </Link>
            </div>
          </div>
        )}
      </nav>
    </>
  );
};

export default PublicNav;
